var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIdeal = function SvgIdeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 40 26"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 21.198,
    height: 18.653,
    x: 9.718,
    y: 3.673,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.916 22.327H9.718V3.673h21.198z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h39.95v26H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Page-1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.074 19.865h3.397v-5.692h-3.397zM15.728 11.327a1.923 1.923 0 1 1-1.923-1.94 1.93 1.93 0 0 1 1.923 1.94"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.675 4.912a8.36 8.36 0 0 1 5.693 1.868c1.54 1.381 2.32 3.474 2.32 6.22 0 5.442-2.62 8.088-8.013 8.088h-10.73V4.912Zm.23-1.239H9.718v18.654h12.187v-.004a9.57 9.57 0 0 0 6.268-1.989c1.82-1.563 2.743-4.03 2.743-7.334a11.5 11.5 0 0 0-.721-4.21 7.7 7.7 0 0 0-2.012-2.936 9.45 9.45 0 0 0-6.278-2.177Z",
    style: {
      mask: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.34 19.872h-4.31V6.42h4.136c3.593 0 7.418 1.432 7.418 6.744 0 5.616-3.825 6.708-7.418 6.708Z",
    style: {
      fill: "#cb1b69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.935 10.441v2.14h.484a1.8 1.8 0 0 0 .393-.031.6.6 0 0 0 .262-.135.7.7 0 0 0 .17-.311 2.1 2.1 0 0 0 .065-.592 2 2 0 0 0-.066-.575.74.74 0 0 0-.184-.313.6.6 0 0 0-.3-.152 3 3 0 0 0-.533-.03Zm-.647-.548h1.183a2.3 2.3 0 0 1 .61.062 1.07 1.07 0 0 1 .483.298 1.4 1.4 0 0 1 .307.524 2.4 2.4 0 0 1 .105.765 2.2 2.2 0 0 1-.099.689 1.4 1.4 0 0 1-.343.572 1.14 1.14 0 0 1-.455.258 2 2 0 0 1-.573.068h-1.218Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.471 9.981a2.2 2.2 0 0 1 .586.058 1 1 0 0 1 .444.274 1.3 1.3 0 0 1 .287.493 2.3 2.3 0 0 1 .1.736 2 2 0 0 1-.094.66 1.35 1.35 0 0 1-.321.537 1.06 1.06 0 0 1-.42.238 1.9 1.9 0 0 1-.547.064h-1.13V9.98Zm-1.27-.177v3.414h1.305a2 2 0 0 0 .6-.073 1.2 1.2 0 0 0 .489-.279 1.5 1.5 0 0 0 .365-.606 2.2 2.2 0 0 0 .103-.718 2.5 2.5 0 0 0-.11-.794 1.5 1.5 0 0 0-.325-.556 1.16 1.16 0 0 0-.522-.322 2.4 2.4 0 0 0-.635-.066Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.226 10.53a2.7 2.7 0 0 1 .514.029.53.53 0 0 1 .26.13.66.66 0 0 1 .16.276 1.9 1.9 0 0 1 .061.547 2 2 0 0 1-.061.566.6.6 0 0 1-.145.272.5.5 0 0 1-.225.114 1.7 1.7 0 0 1-.37.028h-.398V10.53Zm-.379-.177v2.316h.572a1.8 1.8 0 0 0 .414-.033.7.7 0 0 0 .3-.155.76.76 0 0 0 .194-.351 2.2 2.2 0 0 0 .07-.618 2 2 0 0 0-.07-.603.8.8 0 0 0-.208-.35.7.7 0 0 0-.342-.173 3 3 0 0 0-.55-.033ZM19.707 13.129V9.893h2.374v.548h-1.727v.717h1.607v.549h-1.607v.874h1.789v.548z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.994 9.981v.372h-1.728v.894h1.607v.371h-1.607v1.051h1.789v.372h-2.26V9.98Zm-2.374-.177v3.414h2.61v-.726h-1.788v-.697h1.606v-.725h-1.606v-.54h1.727v-.726ZM24.572 11.846l-.442-1.199-.433 1.2Zm1.192 1.283h-.704l-.28-.734h-1.281l-.266.734h-.687l1.246-3.236h.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.422 9.981 1.213 3.06h-.515l-.28-.735h-1.403l-.265.735h-.498l1.178-3.06Zm-.69-.177-1.314 3.414h.876l.266-.735h1.16l.28.735h.894L24.54 9.804Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.13 10.903.316.855h-.624zm-.559 1.032h1.127l-.569-1.544ZM26.305 13.129v-3.21h.647v2.662h1.611v.548z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.864 10.008v2.661h1.611v.372h-2.082v-3.033Zm-.647-.177v3.387h2.434v-.726h-1.612V9.831Z",
    style: {
      fill: "#fff"
    }
  })));
};
export { SvgIdeal as ReactComponent };
export default "/_next/static/images/ideal.svg";